import { companyRequestDoc, user } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  getCompanyRequestAttachmentList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${companyRequestDoc.companyRequestDocBase}`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  companyRequestAttachment(payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(companyRequestDoc.companyRequestDocBase, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

  getDownloadDocumentsBlobObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${companyRequestDoc.companyRequestDocBase}${id}/download/`, {
          responseType: "blob",
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  deleteCompanyRequestDocument(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${companyRequestDoc.companyRequestDocBase}${id}`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
